import { API_INTERNAL_ENDPOINT } from './constants'
import { type schemaType } from './schema'
import { type paramsType } from './paramsSchema'
import fetchUserIsLogged from '~/modules/api/rurality/v3/user/is-logged'
import { useUserStore } from '~/modules/auth/stores/userStore'

export type returnType = ApiServerResponse<schemaType>

export default async (params: paramsType): Promise<returnType> => {
  const runtimeConfig = useRuntimeConfig()

  const url = `${runtimeConfig.public.NUXT_API_CONTENT_ROOT_URL}/${API_INTERNAL_ENDPOINT}`

  const data = (await $fetch(url, {
    body: {
      ...params,
    },
    method: 'POST',
  })) as returnType

  if (data.success) {
    const authUserIsLogged = await fetchUserIsLogged()

    const userStore = useUserStore()
    userStore.setUser(authUserIsLogged)
  }

  return data
}
